export default {
  setDesigners() {
    return new Promise(resolve => {
      this.designers.setValues({
        obj: this.submissionDesigners,
        value: 'id',
        name: 'name',
        multiple: true
      })
      this.ready.state = 'set'
      resolve()
    })
  },
  setSignupDesigners() {
    return new Promise(resolve => {
      this.designers.setValues({
        obj: this.designersList,
        value: 'id',
        name: 'name',
        multiple: true
      })
      resolve()
    })
  },
  updateDesignersValues(val) {
    /*
     * Updates designers in submission.
     */
    this.designers.state = 'set'
    this.designers.update(val, this.updateSubmission)
    if(this.submission?.userMetaData?.tags?.length > 0) {
      let tagList = this.submission?.userMetaData?.tags?.map(tag => tag.name)
      let valList = val.map(designer => designer.label)
      let matchingValues = tagList.filter(tag => {
        return valList.some(designerLabel => {
          let regex = new RegExp(`^${designerLabel}$`, 'i')
          return regex.test(tag)
        });
      });
      if (matchingValues.length > 0) {
        this.$store.commit('designers/setTagValidation', true)
        this.$store.commit('designers/setSameTagName', matchingValues)
      } else {
        this.$store.commit('designers/setTagValidation', false)
      }
    }
  },
  updateSignupDesignersValues(val) {
    /*
     * update designer values specially for signup steps
     */
    this.designers.state = 'set'
    this.designers.update(val, this.watchDuplicatesAndDesignersExist)
  },
  isDesignerSearchAllowed(search) {
    return (
      search.length >= this.designersMinLength &&
      search.indexOf(this.designersExcludeChar) === -1
    )
  },
  getDesignerOptions(search, loading) {
    /**
     * Fetch after little delay.
     */
    this.searchingDesigners = true
    if (!search.length) return
    this.designerStopSearching()
    this.inputDelay.set(() => {
      this.fetchDesigners(search, loading).catch(() => {})
    }, 400)
  },
  setDesignerOptions() {
    return new Promise(resolve => {
      this.designers.setOptions({
        obj: this.designersList,
        value: 'id',
        name: 'name',
        multiple: true
      })
      resolve()
    })
  },
  designerStopSearching() {
    if (this.designers.loading) {
      this.designers.loading(false)
      this.designers.loading = null
    }
    this.inputDelay.clear()
    this.hideDrop = true
    this.clearDesignersOptions()
  },
  fetchDesigners(search, loading) {
    return new Promise((resolve, reject) => {
      if (!this.isDesignerSearchAllowed(search)) {
        reject(new Error('Designer search is not allowed for the given search term.'));
      } else {
        this.designers.loading = loading
        this.designers.loading(true)
        this.$store
          .dispatch('designers/getDesigner', { name: search })
          .then(values => {
            if (!this.designers.loading) {
              this.hideDrop = true
              return null
            } else {
              return this.setDesignerOptions()
            }
          })
          .then(loading => {
            if (loading !== null) {
              this.searchingDesigners = false
              this.hideDrop = false
              this.designers.loading(false)
            }
            resolve()
          })
          .catch(error => {
            this.searchingDesigners = false
            this.hideDrop = false
            this.designers.loading(false)
            reject(new Error(error))
          })
      }
    })
  },
  focusDesignerSearch(search) {
    this.hideDrop = !this.isDesignerSearchAllowed(search)
    if (search.length < this.designersMinLength) {
      this.clearDesignersOptions()
    }
  },
  clearDesignersOptions() {
    this.$store.dispatch('designers/clear')
    this.setDesignerOptions()
  },
  buildSubmission() {
    return new Promise(resolve => {
      this.submissionDesigners = this.designers.getApiValues({
        value: 'id',
        name: 'name',
        multiple: true
      })
      /**
       * Done.
       */
      resolve()
    })
  }
}
